import React from "react";
import {
  Container,
  Row,
  Col,
  Navbar,
  Nav,
  Form,
  Button,
} from "react-bootstrap";
import * as Ai from "react-icons/ai";
import logo from "../images/greenway-logo-light.png";

import "./footer.css";

export default function Footer({ aboutUsData, siteData, operatingHours }) {
  return (
    <>
      <Navbar
        bg="dark"
        variant="dark"
        expand="lg"
        id="footer"
        className="footer text-light"
        style={{
          backgroundImage: "url(images/footer-bg.jpg)",
          backgroundSize: "cover",
        }}
      >
        <Container>
          <Row className="d-flex flex-grow-1 justify-content-center p-4">
            <Col s={12} md={4} className="pb-4">
              <Navbar.Brand>
                <img
                  src={logo}
                  height="60"
                  className="d-inline-block align-top mb-4"
                  alt="GreenWay Landscaping logo"
                />
              </Navbar.Brand>
              <div className="fs-6 text-light pb-2">
                {aboutUsData.aboutUsShort}
              </div>
              <Nav className="flex-row">
                <Nav.Link
                  href="https://www.facebook.com/GreenWayLandscaping"
                  className="ps-0"
                >
                  <Ai.AiFillFacebook size="30" />
                </Nav.Link>
                <Nav.Link href="https://twitter.com/GreenWayL">
                  <Ai.AiFillInstagram size="30" />
                </Nav.Link>
              </Nav>
            </Col>
            <Col s={12} md={4} className="pb-4">
              <h5>Opening Hours</h5>
              <hr
                style={{
                  width: "10%",
                  borderTop: "6px solid var(--primary)",
                  opacity: "1",
                  borderRadius: "10px",
                }}
              />
              {Object.keys(operatingHours).map((day, index) => (
                <p key={index}>
                  {operatingHours[day].close === "" ? (
                    <Ai.AiFillCloseCircle
                      color={"var(--primary-light)"}
                      className="me-2"
                    />
                  ) : (
                    <Ai.AiFillCheckCircle
                      color={"var(--primary-light)"}
                      className="me-2"
                    />
                  )}
                  <span className="day">
                    {day.charAt(0).toUpperCase() + day.slice(1)}:
                  </span>{" "}
                  <span className="time">
                    {operatingHours[day].open}{" "}
                    {operatingHours[day].close === "" ? "" : "- "}
                    {operatingHours[day].close}
                  </span>
                </p>
              ))}
            </Col>
            <Col s={12} md={4} className="pb-4">
              <h5>Contact Us</h5>
              <hr
                style={{
                  width: "10%",
                  borderTop: "6px solid var(--primary)",
                  opacity: "1",
                  borderRadius: "10px",
                }}
              />
              <div className="fs-5 fw-bold pt-2">Call Us</div>
              <div>{siteData.phoneNumber}</div>
              <div className="fs-5 fw-bold pt-4">Email Us</div>
              <div>{siteData.email}</div>
              <div className="fs-5 fw-bold pt-4">Visit Us</div>
              <div>{siteData.address}</div>
            </Col>
          </Row>
        </Container>
      </Navbar>
      <div
        className="d-flex justify-content-center p-2 text-light"
        style={{ backgroundColor: "var(--primary-darkest)" }}
      >
        © 2023 Greenway Landscaping. All Rights Reserved.
      </div>
    </>
  );
}
